// Panel del módulo Administración sobre las clases existentes
// (`.panel`, `.panel__head/__title/__sub/__actions`, `.panel__body`,
// `.panel__body--flush`, `.panel__foot`, dashboard.css). `flush` quita
// el padding del cuerpo para listas y tablas que llegan al borde.
//
// El título es un <h2> (bajo el <h1> de PageHeader); `.ag-panel__title`
// solo le quita el margen por defecto del navegador.

import type { ReactNode } from "react";

export type PanelProps = {
  title?: ReactNode;
  /** Texto secundario junto al título (resumen numérico, alcance). */
  sub?: ReactNode;
  /** Botones a la derecha de la cabecera. */
  actions?: ReactNode;
  /** Pie con fondo paper-2 (leyendas, notas, «Ver registro»). */
  foot?: ReactNode;
  /** Cuerpo sin padding, para tablas y listas a sangre. */
  flush?: boolean;
  /** id del <h2>, para enlazar una región o una tabla al título. */
  titleId?: string;
  className?: string;
  children?: ReactNode;
};

export function Panel({
  title,
  sub,
  actions,
  foot,
  flush = false,
  titleId,
  className,
  children,
}: PanelProps) {
  const hasHead = Boolean(title || sub || actions);
  return (
    <div className={className ? `panel ${className}` : "panel"}>
      {hasHead && (
        <div className="panel__head">
          {title && (
            <h2 id={titleId} className="panel__title ag-panel__title">
              {title}
            </h2>
          )}
          {sub && <span className="panel__sub">{sub}</span>}
          {actions && <div className="panel__actions">{actions}</div>}
        </div>
      )}
      <div className={flush ? "panel__body--flush" : "panel__body"}>{children}</div>
      {foot && <div className="panel__foot">{foot}</div>}
    </div>
  );
}
